class DrawerPopupManager {
  /**
   * Creates a new instance of DrawerPopupManager.
   * @param {HTMLElement} popupWrapper - The element that represents the popup.
   * @param {HTMLElement} openButton - The button that opens the popup.
   * @param {Array<string>|string} closeButtons - An array of selectors for the close buttons or a single selector.
   * @param {string} [openClass='popup-open'] - The class that is added to display the popup.
   */

  constructor(
    popupWrapper,
    openButton,
    closeButtons,
    openClass = ".drawer-popup--show"
  ) {
    this.popupWrapper = popupWrapper;
    this.openButton = openButton;
    this.closeButtons = Array.isArray(closeButtons)
      ? closeButtons
      : [closeButtons];
    this.openClass = openClass;
    this.gridItem = null;

    this.initialize();
  }

  initialize() {
    this.gridItem = document.querySelector(
      ".pdp--main-section.pdp--main-section-v3 .grid--v3 .grid__item.grid__item--content"
    );

    this.openButton?.addEventListener("click", () => {
      if (!this.popupWrapper?.classList.contains(this.openClass)) {
        this.open();
      }
    });

    this.closeButtons?.forEach((button) => {
      if (this.openButton?.classList.contains("js-remove-sticky")) {
        if (this.gridItem) {
          this.gridItem.style.position = "sticky";
        }
      }
      if (button) {
        document.querySelector(button)?.addEventListener("click", () => {
          if (this.popupWrapper?.classList.contains(this.openClass)) {
            this.close();
          }
        });
      }
    });
  }

  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  open() {
    if (this.openButton?.classList.contains("js-remove-sticky")) {
      const topOffset = window.pageYOffset;

      if (this.gridItem) {
        this.gridItem.style.position = "relative";
        this.gridItem.style.top = `${topOffset}px`;
      }
    }
    const scrollbarWidth = this.getScrollbarWidth();
    document.body.style.setProperty("overflow", "hidden", "important");
    document.body.style.setProperty(
      "padding-right",
      `${scrollbarWidth}px`,
      "important"
    );
    this.popupWrapper?.classList.add(this.openClass);
  }

  close() {
    document.body.style.setProperty("overflow", "auto", "important");
    document.body.style.setProperty("padding-right", "0", "important");
    this.popupWrapper?.classList.remove(this.openClass);

    if (this.gridItem) {
      setTimeout(() => {
        this.gridItem.style.position = "sticky";
        this.gridItem.style.top = "140px";
      }, 400);
    }
  }
}
